import React, { useCallback, useEffect } from 'react';
import { Grid } from '@mui/material';

import DetailsCard from '../../../common/details-card/DetailsCard';
import BankDetailsCard from '../../../common/bank-details-card/BankDetailsCard';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import {
  fetchBusinessProfileBankDetails,
  selectBusinessProfileBankDetails,
} from '../../../slices/business-profile/businessProfileSlice';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { Company } from '../../../models/company.model';

interface DetailsTabsProps {
  company: Company;
  key: string;
}

const DetailsTabs: React.FC<DetailsTabsProps> = ({ company }) => {
  const dispatch = useAppDispatch();
  const BusinessProfileBankDetails = useAppSelector(selectBusinessProfileBankDetails);

  const fetchBankDetails = useCallback(() => {
    if (company?.id) {
      dispatch(fetchBusinessProfileBankDetails({ companyId: company?.id }));
    }
  }, [dispatch, company?.id]);

  useEffect(() => {
    fetchBankDetails();
  }, [fetchBankDetails]);

  return (
    <>
      <Grid container wrap='wrap' rowGap={2}>
        <Grid size={{ xs: 12 }}>
          <DetailsCard company={company} />
        </Grid>

        <Grid size={{ xs: 12 }}>
          {BusinessProfileBankDetails &&
            BusinessProfileBankDetails.length > 0 &&
            BusinessProfileBankDetails.map((bank) => (
              <Grid key={bank.id}>
                <BankDetailsCard bank={bank} />
              </Grid>
            ))}
        </Grid>
      </Grid>
    </>
  );
};

export default DetailsTabs;
